import * as types from './constants';

// Get Reimbursements
export const getReimbursementsRequest = data => (
  { type: types.GET_REIMBURSEMENTS_REQUEST, payload: data }
);

export const getReimbursementsDone = data => (
  { type: types.GET_REIMBURSEMENTS_DONE, payload: data }
);

export const getReimbursementsFailed = errors => (
  { type: types.GET_REIMBURSEMENTS_FAILED, payload: errors }
);

export const getReimbursementsReset = () => (
  { type: types.GET_REIMBURSEMENTS_RESET }
);

// Operations
export const toggleReimbursement = data => (
  { type: types.TOGGLE_REIMBURSEMENT, payload: data }
);

export const toggleAllReimbursements = data => (
  { type: types.TOGGLE_ALL_REIMBURSEMENTS, payload: data }
);

export const setFilter = data => (
  { type: types.SET_REIMBURSEMENTS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_REIMBURSEMENTS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_REIMBURSEMENTS_FILTERS, payload: { filterToUpdate, mobile } }
);

export const reimbursementsSetPage = data => (
  { type: types.REIMBURSEMENTS_SET_PAGE, payload: data }
);